import { create } from 'zustand';

export enum EModalChooseWinnerView {
  CHOOSE_TEMPLATE = 'CHOOSE_TEMPLATE',
  ASSIGNED_PAGES = 'ASSIGNED_PAGES',
}

export interface IChooseWinnerStore {
  isOpen: boolean;
  currentView: EModalChooseWinnerView;
  openModal: () => void;
  closeModal: () => void;
  showAssignedPages: () => void;
  showChooseTemplate: () => void;
  resetView: () => void;
}

export const useChooseWinnerStore = create<IChooseWinnerStore>((set) => ({
  isOpen: false,
  currentView: EModalChooseWinnerView.CHOOSE_TEMPLATE,
  openModal: () => {
    set(() => ({ isOpen: true, currentView: EModalChooseWinnerView.CHOOSE_TEMPLATE }));
  },
  closeModal: () => {
    set(() => ({ isOpen: false, currentView: EModalChooseWinnerView.CHOOSE_TEMPLATE }));
  },
  showAssignedPages: () => {
    set(() => ({ currentView: EModalChooseWinnerView.ASSIGNED_PAGES }));
  },
  showChooseTemplate: () => {
    set(() => ({ currentView: EModalChooseWinnerView.CHOOSE_TEMPLATE }));
  },
  resetView: () => {
    set(() => ({ currentView: EModalChooseWinnerView.CHOOSE_TEMPLATE }));
  },
}));
